import { ReactElement, useEffect } from 'react';
import { initialAllEndUsersFilter } from '../allEndUserList';
import { useFilterStore } from '@store/index';
import { useInfiniteScroll } from '@components/common';
import { Wrapper } from '@components/common/Wrapper/wrapper';
import { useComponentLevelAccessCheck } from '../../../../authGuard/hooks/useComponentLevelAccessCheck';
import { useUserRoleType } from '@hooks/useUserRoleType';
import { GetMemberListData } from '@services/hooks/endusers/useMembersListRxDb';
import { RigidUserObject, useRigidAllUserQuery } from '@services/hooks/endusers/rigitAllUser';
import { RigidUserCard } from './rigidUserCard';
import { useRefetchList } from '@helper/fetchData';

export const AllRigidUserList = (): ReactElement => {
	const { isFetching: queryFetching, error, refetch } = useRigidAllUserQuery();
	const { updateSearch, updateSortObject, updateFilterObject, updateSortValue, updateSortActiveStatus } =
		useFilterStore((state) => state);
	const { fetchMore, isFetching, result } = GetMemberListData('all_rigid');
	const checkSubContractorPermission = useComponentLevelAccessCheck('sub-contractor');
	const userRole = useUserRoleType();
	useRefetchList(['AllRigidUser']);

	useEffect(() => {
		updateSortObject([
			{ value: 'priority', name: 'Priority Order' },
			{ value: 'glue_consumption_per_month', name: 'Glue Potential' },
			{ value: 'pwg_banking_qtd', name: 'PWG Banking in Quarter' },
		]);
		updateSortValue('');
		updateSortActiveStatus(false);
		updateSearch('');
		updateFilterObject({
			...initialAllEndUsersFilter,
			customToggle: {
				flagged: true,
				data: [
					{ value: 'OB' },
					{ value: 'ZBC' },
					{ value: 'Degrowing' },
					{ value: 'Adopted' },
					{ value: 'Disengaged' },
					{ value: 'SSM' },
					...(!checkSubContractorPermission ? [{ value: 'Sub Contractor' }] : []),
				],
				toggleData: [],
			},
			largeContractor: {
				flagged: true,
				name: 'Large Contractor',
				dropDownData: '',
				value: '',
			},
			mdicodeDropdown: {
				flagged: userRole === 'RBDM',
				name: 'MDI Code',
				data: [],
				dropDownData: '',
			},
			rigidGluePotential: { flagged: false, enabled: false },
		});
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	useInfiniteScroll(() => {
		fetchMore();
	});

	return (
		<Wrapper isLoaderVisible={queryFetching || (isFetching && result.length === 0)} isError={error}>
			<div className="user-card-list-wrapper">
				<ul className="user-card-list row">
					{result.length > 0 ? (
						result.map((endUser, index) => {
							return (
								<RigidUserCard
									key={endUser?._data.id}
									userObject={endUser._data as unknown as RigidUserObject}
									index={index}
									state={'/all'}
									refetchRigidUsers={refetch}
								/>
							);
						})
					) : (
						<li className="d-col d-col-2">
							<p className="h3">No Data Found!</p>
						</li>
					)}
				</ul>
			</div>
		</Wrapper>
	);
};
